import React from "react"
import { Row ,Col } from "antd";
import './style.scss'

const arrtop = [
    {img:'https://img.alicdn.com/imgextra/i2/O1CN01U98Ecw1bwmlgl5a67_!!6000000003530-2-tps-236-128.png',name:'Paper submission deadline'},
    {img:'https://img.alicdn.com/imgextra/i3/O1CN01U3sCUY1tTcdEM9Pwq_!!6000000005903-2-tps-236-128.png',name:'Notification to authors'},
    {img:'https://img.alicdn.com/imgextra/i4/O1CN01azVGKp1aZb6D804vD_!!6000000003344-2-tps-236-128.png',name:'Camera ready deadline'},
];

export default function Paper() {
    return <div className="page-paper">
            <div className="paper-title">
                Paper Submissions
            </div>
            <div className className="paper-con">
                <Row className="paper-top">
                    {arrtop.map((item,index) => (
                        <Col lg={8} md={12} span={24} key={index}>
                            <img className="noimg" alt="" src={item.img} />
                            <span dangerouslySetInnerHTML={{__html:item.name}} />
                        </Col>
                    ))}
                </Row>
            </div>
    </div>
}

